import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5b8f60bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "routeSubscriptionCardsWrapper" }
const _hoisted_3 = { class: "textCode" }
const _hoisted_4 = { class: "bold" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "rightButtonsWrapper" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "apiError" }

import {
  computed, ref, Ref, watch,
} from 'vue';
import { Skeletor } from 'vue-skeletor';
import { useI18n } from 'vue-i18n';
import {
  Card, Button, Icon, Spinner,
} from '../../Atoms';
import { DeleteRouteSubscriptionModal } from '../DeleteRouteSubscriptionModal';
import { RouteSubscription } from '../RouteSubscription';
import { validateSubscription } from '../../helpers';
import { RouteDetail, RouteSubscriptionViewModel, SmsErrors } from '../../types';
import { useRouteSubscriptionStore } from '../../stores';


export default /*#__PURE__*/_defineComponent({
  __name: 'RouteSubscriptionCard',
  props: {
    startDate: {},
    endDate: {},
    routes: {},
    textCode: {},
    isLoading: { type: Boolean, default: false },
    isUpdating: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;
const { t } = useI18n();

const routeSubscriptionsStore = useRouteSubscriptionStore();
const {
  updateSubscription,
  deleteSubscription,
  getSubscriptions,
} = routeSubscriptionsStore;

const mode: Ref<'view' | 'edit'> = ref('view');

const subscription: Ref<RouteSubscriptionViewModel> = ref({
  startDate: undefined,
  endDate: undefined,
  textCode: undefined,
});

const errors: Ref<SmsErrors> = ref({
  textCode: false,
  rangeError: false,
});

const showErrors = ref(false);
const apiError = ref('');
const isError = computed(() => Object.values(errors.value).some((err) => err));
const showDeleteModal = ref(false);

watch(() => subscription.value, (value) => {
  errors.value = validateSubscription(value);
}, { deep: true });

const handleEdit = () => {
  mode.value = 'edit';
};

const resetFields = () => {
  subscription.value = {
    startDate: props.startDate,
    endDate: props.endDate,
    textCode: props.textCode,
  };
};

resetFields();

const handleUpdateStartDate = (date: string) => {
  subscription.value.startDate = date;
};

const handleUpdateEndDate = (date: string) => {
  subscription.value.endDate = date;
};

const handleSave = async () => {
  showErrors.value = true;

  if (isError.value) {
    return;
  }

  apiError.value = '';

  updateSubscription({
    routeSubscription: {
      startDate: subscription.value.startDate || '',
      endDate: subscription.value.endDate || '',
      textCode: subscription.value.textCode || '',
    },
    onApiSuccess: () => {
      mode.value = 'view';
      getSubscriptions();
    },
    onApiError: () => {
      apiError.value = t('SMS Api error');
    },
  });
  showErrors.value = false;
};

const handleDelete = () => {
  showDeleteModal.value = true;
};

const handleConfirmDelete = () => {
  apiError.value = '';
  deleteSubscription({
    textCode: props.textCode,
    onApiSuccess: () => {
      getSubscriptions();
    },
    onApiError: () => {
      apiError.value = t('SMS Api error');
    },
  });
};

const handleCancelDelete = () => {
  showDeleteModal.value = false;
};

const handleCancel = () => {
  resetFields();
  mode.value = 'view';
  apiError.value = '';
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Card), { class: "routeSubscriptionCard" }, {
        default: _withCtx(() => [
          _createVNode(_unref(RouteSubscription), {
            mode: mode.value,
            "is-loading": _ctx.isLoading,
            routes: _ctx.routes,
            "text-code": subscription.value.textCode,
            "start-date": subscription.value.startDate,
            "end-date": subscription.value.endDate,
            "range-error": errors.value.rangeError && showErrors.value,
            "route-error": errors.value.textCode && showErrors.value,
            onUpdateStartDate: handleUpdateStartDate,
            onUpdateEndDate: handleUpdateEndDate
          }, null, 8, ["mode", "is-loading", "routes", "text-code", "start-date", "end-date", "range-error", "route-error"]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('Text code')) + ":", 1),
            (!_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.textCode), 1))
              : _createCommentVNode("", true),
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_unref(Skeletor), {
                  key: 1,
                  class: "skeletorTextCode",
                  width: "20"
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["subscriptonButtonsWrapper", { edit: mode.value === 'edit' }])
          }, [
            _withDirectives(_createElementVNode("button", {
              class: "deleteButton",
              onClick: handleDelete
            }, [
              _createVNode(_unref(Icon), { "icon-name": "smsDelete" }),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('Delete')), 1)
            ], 512), [
              [_vShow, !_ctx.isLoading]
            ]),
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_7, [
              (mode.value === 'edit')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_unref(Button), {
                      type: "button",
                      class: "button secondary",
                      label: _ctx.$t('Cancel'),
                      secondary: true,
                      "on-click": handleCancel
                    }, null, 8, ["label"]),
                    _createVNode(_unref(Button), {
                      disabled: _unref(routeSubscriptionsStore).isSubscriptionUpdating,
                      type: "button",
                      class: "button",
                      label: _ctx.$t('Save changes'),
                      "on-click": handleSave
                    }, {
                      default: _withCtx(() => [
                        (_ctx.isUpdating)
                          ? (_openBlock(), _createBlock(_unref(Spinner), {
                              key: 0,
                              class: "spinner"
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["disabled", "label"])
                  ]))
                : _createCommentVNode("", true),
              (mode.value === 'view')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (!_ctx.isLoading)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "button editButton",
                          onClick: handleEdit
                        }, [
                          _createVNode(_unref(Icon), { "icon-name": "smsEdit" }),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t('Edit details')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.isLoading)
                      ? (_openBlock(), _createBlock(_unref(Skeletor), {
                          key: 1,
                          class: "vue-skeletor",
                          height: "35",
                          width: "162"
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2),
          (apiError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(apiError.value), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (showDeleteModal.value)
        ? (_openBlock(), _createBlock(_unref(DeleteRouteSubscriptionModal), {
            key: 0,
            to: "#modal",
            error: apiError.value,
            onConfirm: handleConfirmDelete,
            onCancel: handleCancelDelete
          }, null, 8, ["error"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})